module.exports = __webpack_public_path__ + "static/img/xingtan.60a2f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xingtan.jpg
// module id = m8Fx
// module chunks = 5